/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const deleteCampaignPipelineStageDataSchema = z.object({
	migrateCandidatesTo: z.string().uuid().nullable().optional(),
})

export type DeleteCampaignPipelineStageDataSchema = z.infer<typeof deleteCampaignPipelineStageDataSchema>
